module.exports = __webpack_public_path__ + "RMR HRA Enrollment Guide.pdf";